module.exports = "/_next/static/images/login-0d29350c48158c9e420d07f069c01dd7.png";